import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "@material-ui/core";
import { useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Search } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";

const ClientSettingDetails = ({props}) => {
    const isMobile = useMediaQuery("(max-width:767px)");
    const isLandscape = useMediaQuery(
      "(min-width: 771px) and (max-width: 940px)"
    );
    const [searchTerm, setsearchTerm] = React.useState("");
    const [deleteDialog, setDeleteDialog] = React.useState(false);
    const [deleteTaskListDialog, setDeleteTaskListDialog] = React.useState(false);
    const [temptTask, setTemptTask] = React.useState(null);
    const [temptServices, setTemptServices] = React.useState(null);

    const {newServiceType, setNewServiceType, styles, errors, editingBusiness, handleSaveServiceTypeEdit, handleAddServiceType, serviceTypes, 
        setEditingBusiness, setDialogOpen, handleDeleteServiceType, newTask, setNewTask, handleSaveTaskEdit, handleCancelTask, handleAddTask, getBusinessTasks, 
        editingTask, setEditingTask, handleDeleteTask
    } = props;

    const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.title)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList = serviceTypes?.filter((item) => {
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;
    return matchesSearch
  });


  const handleDeleteCofirm = () => {
    handleDeleteTask(temptTask?.id);
    setDeleteDialog(false);
    setTemptTask(null);
  }

  const handleDeleteClose = () => {
    setDeleteDialog(false);
    setTemptTask(null);
  }

  const handleDeleteTaskListCofirm = () => {
    handleDeleteServiceType(temptServices?.id);
    setDeleteTaskListDialog(false);
    setTemptServices(null);
  }

  const handleDeleteTaskListClose = () => {
    setDeleteTaskListDialog(false);
    setTemptServices(null);
  }

    return (
      <>
        <div className="relative flex-1 min-w-[140px] mb-10">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <Input
            placeholder="Search Services..."
            className="pl-40"
            id="searchTerm"
            value={searchTerm}
            onChange={(e) => setsearchTerm(e.target.value)}
          />
        </div>
        <div className="space-y-6">
          <Card className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader className="pb-12 pt-24 ph-24">
              <CardTitle className="text-xl">
                Manage Industry and Services
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-0 pb-24 ph-24">
              <div>
                <input
                  type="text"
                  placeholder="Service Type Name"
                  value={newServiceType?.name}
                  onChange={(e) =>
                    setNewServiceType((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  className={`${styles?.textInput} dark:bg-[#0F1729]`}
                />
                {errors?.serviceTypeName && !newServiceType?.name && (
                  <span className="d-flex small error color-danger">
                    Service Type Name Required
                  </span>
                )}
                <input
                  type="text"
                  placeholder="Service Type Description"
                  value={newServiceType?.description}
                  onChange={(e) =>
                    setNewServiceType((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  className={`${styles?.textInput} mt-10 dark:bg-[#0F1729]`}
                />
                {errors?.serviceTypeDescription &&
                  !newServiceType?.description && (
                    <span className="d-flex small error color-danger">
                      Service Type Description Required
                    </span>
                  )}

                <Button
                  variant="contained"
                  onClick={
                    editingBusiness
                      ? handleSaveServiceTypeEdit
                      : handleAddServiceType
                  }
                  className="ph-35 mr-5 mt-15"
                  style={{
                    backgroundColor: "#078037",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  <AddIcon />{" "}
                  {editingBusiness
                    ? "Update Industry Type"
                    : "Add Indusrty Type"}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setEditingBusiness(null);
                    setNewServiceType({ name: "", description: "" });
                  }}
                  className="ph-35 mr-10 mt-15"
                  style={{
                    backgroundColor: "gray",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  Cancel
                </Button>
              </div>
              <div className="mt-40">
                <div className={styles?.categoriesList}>
                  {filteredList
                    ?.filter((business) => !business?.deleted)
                    ?.map((business, index) => (
                      <div key={business?.id} className={`${styles?.categoryCard} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                        <div className={`${styles?.categoryHeader2} dark:bg-[#1A1F2C]`}>
                          <div>
                            <h2 className="dark:text-white"
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              {index + 1}. {business?.title}
                            </h2>
                            {/* <div>{business.description}</div> */}
                          </div>
                          <div className={isMobile ? "mt-8 w-100" : ""}>
                            <Button
                              variant="contained"
                              className={isMobile ? "p-4 mr-8" : "p-4 mr-8"}
                              style={{
                                backgroundColor: "#078037",
                                color: "white",
                                boxShadow: "none",
                                width: "40%",
                              }}
                              onClick={() => {
                                setEditingBusiness(business);
                                setNewServiceType({
                                  name: business?.title,
                                  description: business?.description,
                                });
                                setDialogOpen(true);
                              }}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              className={isMobile ? "p-4 mr-8" : "p-4 mr-8"}
                              style={{
                                backgroundColor: "red",
                                color: "white",
                                boxShadow: "none",
                                width: "40%",
                              }}
                              onClick={() => {
                                setDeleteTaskListDialog(true);
                                setTemptServices(business)
                              }}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                        <div className={styles?.itemsList}>
                          <div className={styles?.inputGroup}>
                            <input
                              type="text"
                              placeholder="Task Name"
                              value={newTask[business.id]?.taskName || ""}
                              onChange={(e) =>
                                setNewTask({
                                  ...newTask,
                                  [business.id]: {
                                    ...(newTask[business.id] || {}),
                                    taskName: e.target.value,
                                  },
                                })
                              }
                              className={`${styles?.textInput} dark:bg-[#0F1729]`}
                              style={{ width: isMobile ? "" : "45%" }}
                            />
                            {errors[business.id]?.serviceTaskName &&
                              !newTask[business.id]?.taskName && (
                                <span className="d-flex small error color-danger">
                                  Task Name Required
                                </span>
                              )}
                            <input
                              type="text"
                              placeholder="Task Description"
                              value={newTask[business.id]?.description || ""}
                              onChange={(e) =>
                                setNewTask({
                                  ...newTask,
                                  [business.id]: {
                                    ...(newTask[business.id] || {}),
                                    description: e.target.value,
                                  },
                                })
                              }
                              className={`${styles?.textInput} dark:bg-[#0F1729]`}
                              style={{ width: isMobile ? "" : "45%" }}
                            />
                            {errors[business.id]?.serviceTaskDes &&
                              !newTask[business.id]?.description && (
                                <span className="d-flex small error color-danger">
                                  Task Description Required
                                </span>
                              )}
                            <div className={isMobile ? "w-100" : ""}>
                              {editingTask?.parentCategoryId === business.id ? (
                                <div className="d-flex">
                                  <Button
                                    className={`${styles?.btn} ${styles?.btnSuccess} mr-20`}
                                    onClick={() =>
                                      handleSaveTaskEdit(business?.id)
                                    }
                                  >
                                    Save Task
                                  </Button>
                                  <Button
                                    className={`${styles?.btn} ${styles?.btnSuccess}`}
                                    onClick={() =>
                                      handleCancelTask(business?.id)
                                    }
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  className={`${styles?.btn} ${styles?.btnSuccess} mr-20`}
                                  onClick={() => handleAddTask(business?.id)}
                                >
                                  Add Task
                                </Button>
                              )}
                            </div>
                          </div>

                          {getBusinessTasks(business?.id)?.map(
                            (task, taskIndex) => (
                              <div
                                key={task?.id}
                                className={`${styles?.itemCard} dark:border-0`}
                              >
                                <div className={styles?.itemHeader}>
                                  <h3 className="text-[#020817] dark:text-white">
                                    {taskIndex + 1}. {task?.title}
                                  </h3>

                                  {!isMobile && task?.description && (
                                    <p className={styles?.itemDescription}>
                                      {task.description}
                                    </p>
                                  )}

                                  <div className={styles?.itemActions}>
                                    <Button
                                      className={styles?.editBtn}
                                      onClick={() => {
                                        setEditingTask(task);
                                        setNewTask({
                                          ...newTask,
                                          [business.id]: {
                                            taskName: task?.title,
                                            description: task?.description,
                                          },
                                        });
                                      }}
                                    >
                                      <EditIcon
                                        fontSize="small"
                                        className={styles?.editIcons}
                                      />
                                    </Button>
                                    <Button
                                      className={styles?.deleteBtn}
                                      onClick={() => {
                                        setDeleteDialog(true);
                                        setTemptTask(task);
                                      }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </Button>
                                  </div>
                                </div>
                                {isMobile && task?.description && (
                                  <p className={styles?.itemDescription}>
                                    {task?.description}
                                  </p>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        {deleteDialog && (
          <CommonConfirmationDialog
            open={deleteDialog}
            onConfirm={handleDeleteCofirm}
            onClose={handleDeleteClose}
            title={"Task Delete"}
            message={"Are you sure you want to delete the task?"}
            buttonTitle={"Yes"}
          />
        )}
        {deleteTaskListDialog && (
          <CommonConfirmationDialog
            open={deleteTaskListDialog}
            onConfirm={handleDeleteTaskListCofirm}
            onClose={handleDeleteTaskListClose}
            title={"Industry Service Delete"}
            message={"Are you sure you want to delete this industry service and all its tasks?"}
            buttonTitle={"Yes"}
          />
        )}
      </>
    );
}

export default ClientSettingDetails;